import React from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { HeroSection } from 'components/hero-section/hero-section.component';

interface PremiumPaymentLayoutProps {
  title: string;
  height?: string;
  goBack?: () => void;
  children: React.ReactNode;
  additionalCss?: Record<string, any>;
}

export const PremiumPaymentLayout: React.FC<PremiumPaymentLayoutProps> = ({
  title,
  height = '120px',
  goBack,
  children,
  additionalCss = {},
}) => (
  <MainPageContainer
    width="100%"
    css={{
      '.GDS-vertical-stack-layout': {
        width: '100%',
      },
      ...additionalCss,
    }}
  >
    <HeroSection title={title} height={height} goBack={goBack} />
    <StackLayout>
      <StackLayout
        css={{
          marginBottom: '$four',
          marginTop: '$one',
        }}
      >
        {children}
      </StackLayout>
    </StackLayout>
  </MainPageContainer>
);
